<template>
  <div class="wrap-layer">
    <light-header :back="true"></light-header>
    <div class="page-layer auto">
      <div v-for="(detail, contracIdx) in details" :key="contracIdx" class="detail-wrap">
        <div class="info-card">

          <div class="area-title">
            <div class="area-title">
              <span class="bar"></span>
              <span> 基本信息 {{ contracIdx > 0 ? "（关联合同）"  : ""}}</span>
            </div>


            <div v-if="detail.reprotStatus">
              <el-button size="small" type="primary" @click="handleApplyCert('apply', contracIdx)"
                v-if="detail.reprotStatus == 'notApply'">申请存证</el-button>
              <el-button size="small" type="primary" @click="handleApplyCert('dl', contracIdx)" v-else :loading="dlLoading">下载存证</el-button>
            </div>
          </div>
          <!-- <div class="card-head">
            <span>
              {{ detail.taskName ? detail.taskName : "加载中..." }}
            </span>
          </div> -->

          <table class="check-task-info-table">
            <tr>
              <td>
                <span>合同主题：</span>
              </td>
              <td>
                <span>{{ detail.taskName }}</span>
              </td>
              <td>
                <span>合同编号：</span>
              </td>
              <td>
                <span>{{ detail.taskNo }}</span>
              </td>
              <td>
                <span>合同状态：</span>
              </td>
              <td>
                <span v-if="detail.status === 'waitSend'">待发送</span>
                <span v-if="detail.status === 'reject'">已拒签</span>
                <span v-if="detail.status === 'draft'">草稿</span>
                <span v-if="detail.status === 'expire'">已过期</span>
                <span v-if="detail.status === 'recall'">已撤回</span>
                <span v-if="detail.status === 'iSign'">待我签署</span>
                <span v-if="detail.status === 'finish'">签署完成</span>
                <span v-if="detail.status === 'otherSign'">待他签署</span>
                <span v-if="detail.status === 'process'">审批中</span>
                <span v-if="detail.status === 'cancel'">已作废</span>
                <span v-if="detail.status === 'archive'">已归档</span>
              </td>
            </tr>
            <tr>
              <td>发起方：</td>
              <td>
                <span>{{ detail.initiatorName }}</span>
              </td>
              <td>发起时间：</td>
              <td>
                <span v-if="detail.signStartTime">
                {{ detail.signStartTime }}
                </span>
                <span v-else> --- </span></td>
              <td>截止时间：</td>
              <td>
                <span>
                  {{ detail.signExpireTime }}
                </span>
              </td>
            </tr>
          </table>


          <div class="file-list" v-if="detail.signFileInfoArray">
            <div class="file-item" v-for="(item, idx) in detail.signFileInfoArray" :key="item.fileId">
              <div class="file-thumb" :class="{ 'is-blank': !item.filePages }">
                <img :src="item.fileImgArray[0]" alt="" />
                <div class="file-count">{{ item.filePages }}页</div>
                <span class="file-actions">
                  <span class="file-preview">
                    <i class="el-icon-zoom-in" @click="item.filePages && handleFilePreview(contracIdx, idx)"></i>
                  </span>
                </span>
              </div>
              <div class="file-name">{{ item.fileName }}</div>
            </div>
          </div>
          <div class="file-list" v-else></div>
          <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
            <img v-for="(img, index) in pngList" :key="index" width="100%" :src="img" alt="" />
          </el-dialog>
        </div>
        <div class="list-card">
          <!-- <div class="card-head">签署方列表</div> -->
          <div class="area-title">
            <span class="bar"></span>
            <span>签署方列表</span>
          </div>
          <div class="table-wrap">
            <el-table :data="detail.signUserArray" size="medium">
              <el-table-column prop="signSequence" label="签署顺序" width="">
                <template slot-scope="scope">
                  <span>{{
                    Boolean(scope.row.signSequence) > 0 ? scope.row.signSequence : "无顺序"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="">
              </el-table-column>
              <el-table-column label="签约主体" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-show="scope.row.personName">{{
                    scope.row.personName
                  }}</span>
                  <span v-show="scope.row.companyName">{{
                    scope.row.companyName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="companyAgentName" label="经办人" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{
                    scope.row.companyAgentName ? scope.row.companyAgentName : "-"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号" width="">
                <template slot-scope="scope">
                  <span v-if="scope.row.personAddress">{{
                    scope.row.personAddress
                  }}</span>
                  <span v-else-if="scope.row.companyAgentAddress">{{
                    scope.row.companyAgentAddress
                  }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="signTime" label="签约时间" width="180" show-overflow-tooltip>
              </el-table-column>
<!--              <el-table-column prop="remark" label="备注" width="">-->
<!--              </el-table-column>-->

            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-drawer title="" :visible.sync="descOpen" direction="rtl" custom-class="desc-drawer" append-to-body
      :show-close="true" :modal="false" :withHeader="true" size="80%">
      <div>
        <desc-drawer :from="'myLaunch'" :descData="descData" @changeDescOpen="changeDescOpen"></desc-drawer>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import lightHeader from "../../components/lightHeader";
import descDrawer from "./descDrawer";
import { mapState } from "vuex";
import { getTaskDetailInfo, applyReport, downReport } from "@/api/template";
import { downloadFile } from "@/utils/index";
export default {
  components: {
    lightHeader,
    descDrawer,
  },
  data() {
    return {
      pngList: [],
      dialogVisible: false,
      detail: {
        taskName: null,
        signUserArray: [],
      },
      details: [],
      descOpen: false,
      descData: [],
      dlLoading: false
    };
  },
  computed: {
    ...mapState(["userInfo", "companyList", "currentSpace"]),
  },
  watch: {
    descOpen(newV, oldV) {
      if (newV) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
  created() {
    this.initGetTaskDetailInfo();
  },
  mounted() { },
  methods: {
    initGetTaskDetailInfo() {
      getTaskDetailInfo({
        signId: this.$route.query.signId,
        taskType: this.$route.query.taskType
      }).then((res) => {
        if (res.code != 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // this.details = res.data.taskDetailInfo;
          this.details = res.data.taskDetailInfo;
        }
      });
    },
    handleFilePreview(contracIdx, idx) {
      this.$nextTick(() => {
        this.descData = {
          signFileInfoArray: [
            {
              fileName: this.details[contracIdx].signFileInfoArray[idx].fileName
                ? this.details[contracIdx].signFileInfoArray[idx].fileName
                : "",
              fileImgArray: this.details[contracIdx].signFileInfoArray[idx].fileImgArray,
            },
          ],
        };
      });

      this.descOpen = true;
    },
    changeDescOpen(status) {
      this.descOpen = status;
    },
    handleApplyCert(type, contracIdx) {
      if (type == 'apply') {
        applyReport({
          taskId: this.$route.query.taskId
        }).then(res => {
          this.$message({
            showClose: true,
            message: res.message,
            type: res.code == 200 ? "success" : "warning",
          });
          this.initGetTaskDetailInfo();
        })
      } else {
        if (this.details[contracIdx].reprotStatus == 'pending') {
          this.$message({
            showClose: true,
            message: "存证生成中，请10分钟后再重试",
            type: "warning",
          });
          this.initGetTaskDetailInfo();
        }
        if (this.details[contracIdx].reprotStatus == 'failed') {
          this.$message({
            showClose: true,
            message: "存证生成失败，请联系管理员",
            type: "warning",
          });
        }
        if (this.details[contracIdx].reprotStatus == 'success') {
          this.dlLoading = true;
          downReport({
            taskId: this.$route.query.taskId
          }).then(res => {
            this.dlLoading = false;
            downloadFile(res, "电子数据签署报告", "pdf");
          }).catch(() => {
            this.dlLoading = false;
          })
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.wrap-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

.info-card {
  background: #fff;
  padding: 20px;


  .area-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-head {
    font-weight: 400;
    color: #333333;
    padding: 1px 8px;
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    border-left: 3px solid #3296fa;
  }

  .card-row {
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    margin-top: 20px;
    line-height: 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0 13px;

    .row-column {
      width: 33.33%;
    }

    &.start {
      justify-content: flex-start;

      div {
        margin-right: 20px;
      }
    }

    span {
      margin-left: 33px;
      color: #333;
    }
  }

  .file-list {
    min-height: 174px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 13px;
    flex-wrap: wrap;

    .file-item {
      margin-top: 26px;
      width: 144px;
      // position: relative;
      margin-right: 15px;

      .file-thumb {
        width: 144px;
        height: 144px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        position: relative;

        img {
          width: 80%;
          height: 80%;
          object-fit: contain;
        }

        .file-count {
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 15px;
          color: #222;
          text-align: center;
          width: 100%;
          padding: 7px 0;
        }

        .file-actions {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          cursor: default;
          text-align: center;
          color: #fff;
          opacity: 0;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: opacity 0.3s;

          .file-preview {
            cursor: pointer;
          }

          .file-delete {
            margin-left: 15px;
            cursor: pointer;
          }

          &::after {
            display: inline-block;
            content: "";
            height: 100%;
            vertical-align: middle;
          }
        }

        .file-actions:hover {
          opacity: 1;
        }

        &.is-blank {
          .file-actions:hover {
            opacity: 0;
          }

          .file-preview {
            cursor: default !important;
          }
        }
      }

      .file-name {
        font-size: 13px;
        font-weight: 400;
        color: #666666;
        margin-top: 12px;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }

    // .file-item + .file-item {
    // 	margin-left: 15px;
    // }
  }
}

.detail-wrap {
  padding-bottom: 30px;

  &:nth-of-type(1) {
    padding-bottom: 0;
  }
}

.list-card {
  // margin-top: 18px;
  background: #fff;
  padding: 26px 23px;

  .card-head {
    font-weight: 400;
    color: #333333;
    padding: 1px 8px;
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    border-left: 3px solid #3296fa;
    margin-bottom: 26px;
  }

  .table-wrap {
    margin-top: 20px;
    // padding: 0 13px;

    .el-table {
      // /deep/ .table-head th {
      //   background: #f9f9ff;

      //   .cell {
      //     color: #000;
      //     font-weight: bold;
      //   }
      // }
    }
  }
}

.check-task-info-table {
  width: 100%;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  margin-top: 25px;
  justify-content: space-between;
  padding: 0 13px;
}
.check-task-info-table > tr{
  height: 45px;
}
</style>
